import { render } from "./PurchaseDetailView.vue?vue&type=template&id=a601c0bc&scoped=true"
import script from "./PurchaseDetailView.vue?vue&type=script&lang=js"
export * from "./PurchaseDetailView.vue?vue&type=script&lang=js"

import "./PurchaseDetailView.vue?vue&type=style&index=0&id=a601c0bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a601c0bc"]])

export default __exports__